export const invoiceHandler = (organizationId: string) => ({
  type: "invoice",
  envelope: { collection: "invoices" },
  relationships: {
    organization: { type: "organization", id: organizationId },
  },
});
